import React from 'react'
import TopDevelopers from '../../components/body/topDevelopersComponents/TopDevelopersPage.Component'
import Navbar from '../../components/Navbar/Navbar'

import { developerlogo } from "./data"
import Main_Footer from '../../components/footer/IndiaFooter/Main_Footer'

const DevelopersPage = () => {
  return (
    <div>
      <Navbar />
      <TopDevelopers developers={developerlogo} />
      <Main_Footer/>
    </div>
  )
}

export default DevelopersPage